module.exports = __webpack_public_path__ + "img/swiper_3.0_3_3.44a58508.webp";